import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// images - Potentielle Bilder für Jumbotron und Gallery
import InfoJumb1 from './images/infoJumbo1.png'; // Ersetzen durch: fanuc-roboter-produktionslinie.jpg
import InfoJumb2 from './images/infoJumbo2.jpg'; // Ersetzen durch: fanuc-cnc-steuerung.jpg
import InfoJumb3 from './images/infoJumbo3.png'; // Ersetzen durch: fanuc-robocut-drahterodieren.jpg
import banner1 from './images/banner.avif'; // Ersetzen durch: fanuc-hauptbanner.jpg

import { Grid, Row, Col, Carousel, Breadcrumb, Button } from 'react-bootstrap';

class Fanuc extends Component {
  render() {
    
    window.scrollTo(0, 0);
    return (
      <div className='container-fluid'>

        <div className="supMain">
          <div className="BC">
            <Breadcrumb className='breadcrumb-item'>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/Suppliers">Lieferanten</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/Suppliers/WuF">WuF</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Fanuc</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <img src={banner1} alt="Fanuc Automatisierungslösungen" />
        </div>

        <div className="supMainText">
          <h1>Fanuc</h1>
          <Grid className="supMainInfo">
            <Row>
              <Col xsHidden smHidden md={3}>
                <Carousel>
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src={InfoJumb1}
                      alt="Fanuc Industrieroboter"
                    />
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src={InfoJumb2}
                      alt="Fanuc CNC-Steuerungen"
                    />
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src={InfoJumb3}
                      alt="Fanuc ROBOCUT Drahterodiermaschinen"
                    />
                  </Carousel.Item>
                </Carousel>
              </Col>
              <Col xsHidden md={8}>
                <h4>
                  FANUC ist ein weltweiter Pionier der Fabrikautomatisierung und Technologieführer bei CNC-Steuerungen, Robotik und ROBOMACHINE-Werkzeugmaschinen. Seit den 1950er Jahren revolutioniert das japanische Unternehmen Fertigungsprozesse weltweit. Mit über 100 Robotermodellen bietet FANUC die größte Auswahl an Industrierobotern auf dem Markt. Die Deutschland-Zentrale in Neuhausen auf den Fildern bei Stuttgart beschäftigt rund 400 Mitarbeiter und ist Teil eines globalen Netzwerks von 210 Niederlassungen in 41 Ländern.  Die Firma Mauersberger übernimmt den Vertrieb für Südbayern.
                </h4>
              </Col>
              <Col xs={12} smHidden mdHidden lgHidden>
                <h4>
                  FANUC ist weltweiter Technologieführer bei CNC-Steuerungen, Industrierobotern und Werkzeugmaschinen mit Hauptsitz in Japan und deutscher Zentrale bei Stuttgart. Die Firma Mauersberger übernimmt den Vertrieb für Südbayern.
                </h4>
              </Col>
              <Col xs={12} md={{ span: 7, offset: 2 }}>
                <Button className="supMainButtonWebPage" variant="light" href="https://www.fanuc.eu/de-de/" target="_blank">Hersteller Homepage</Button>
              </Col>
            </Row>
          </Grid>
          <br />
        </div>

        <section>
          <div className="supMainKeyWords">
            <br />
            <Grid>
              <Row>
                <Col xsHidden sm={4} md={2}>
                  <h5>Über 100 Robotermodelle weltweit</h5>
                </Col>
                <Col xsHidden sm={4} md={2}>
                  <h5>CNC-Steuerungstechnologie seit 1956</h5>
                </Col>
                <Col xsHidden sm={4} md={2}>
                  <h5>ROBOCUT Drahterodiermaschinen</h5>
                </Col>
                <Col xsHidden sm={4} md={2}>
                  <h5>210 Niederlassungen in 41 Ländern</h5>
                </Col>
                <Col xsHidden sm={4} md={2}>
                  <h5>Cobots und Industrieroboter</h5>
                </Col>
                <Col xsHidden sm={4} md={2}>
                  <h5>ROBODRILL und ROBOSHOT Maschinen</h5>
                </Col>
              </Row>
              <br />
              <Row className="show-grid">
                <Col xs={12} smHidden mdHidden lgHidden>
                  <h5>&#9658; &nbsp; Über 100 Robotermodelle weltweit</h5>
                </Col>
                <Col xs={12} smHidden mdHidden lgHidden>
                  <h5>&#9658; &nbsp; CNC-Steuerungstechnologie seit 1956</h5>
                </Col>
                <Col xs={12} smHidden mdHidden lgHidden>
                  <h5>&#9658; &nbsp; ROBOCUT Drahterodiermaschinen</h5>
                </Col>
                <Col xs={12} smHidden mdHidden lgHidden>
                  <h5>&#9658; &nbsp; Cobots und Industrieroboter</h5>
                </Col>
              </Row>
            </Grid>
            <br />
          </div>
        </section>

        <section>
          <Grid className="gridUp">
            <br />
            <center>
              <h1>Produkte</h1>
            </center>
            <br /><br />
            
            
            <Row className="show-grid">              
              {/* ROBOCUT Drahterodieren Sektion */}
              <Col xs={12} sm={6} md={4}>
                <Link to="/Suppliers/Fanuc/Robocut">
                <center>
                  <div className="productsButton">
                    <h4 className="buttonBlue">ROBOCUT Drahterodieren</h4>
                    <h5>Die ROBOCUT α-CiC Serie ermöglicht hochpräzise Drahterosion mit Drähten bis zu 0,05 mm Durchmesser. Ideal für komplexe Konturen in harten Metallen mit höchster Schnittgeschwindigkeit, Oberflächengüte und Maßgenauigkeit.</h5>
                    <p>Mehr ...</p>
                  </div>
                </center>
                </Link>
              </Col>
            </Row>
          
          </Grid>
          <br />
        </section>

      </div>
    );
  }
}

export default Fanuc;


// WEBPACK FOOTER //
// ./src/components/pages/supplier/fanuc/mainPageSup.js